export const EN_MASONRY_QUESTIONNAIRE_STRINGS = {
  // Entity-level
  MASONRY_QUESTIONNAIRE:
    '{count, plural, one {Masonry Questionnaire} other {Masonry Questionnaires}}',
  MASONRY_QUESTIONNAIRE_ENTITY_NAME: 'Masonry Questionnaire',
  MASONRY_QUESTIONNAIRE_DETAILS_LABEL: 'Details',

  // Top-level fields
  MASONRY_QUESTIONNAIRE_TITLE_LABEL: 'Title',
  MASONRY_QUESTIONNAIRE_TITLE_HINT:
    'Member-facing title for the assessment. Shown at the start of the flow and on member dashboards. Keep concise — e.g., "Annual Health Assessment".',
  MASONRY_QUESTIONNAIRE_DESCRIPTION_LABEL: 'Description',
  MASONRY_QUESTIONNAIRE_DESCRIPTION_HINT:
    'Internal description for administrators. Not shown to members. Use to note the purpose, owner, or version.',

  // Sections
  MASONRY_QUESTIONNAIRE_SECTIONS_LABEL: 'Sections',
  MASONRY_QUESTIONNAIRE_SECTIONS_HINT:
    'Group questions into categories. Each section can have an optional title. Use a single unnamed section for an ungrouped flow.',
  MASONRY_QUESTIONNAIRE_SECTION_ADD_LABEL: 'Add section',
  MASONRY_QUESTIONNAIRE_SECTION_ITEM: 'Section',
  MASONRY_QUESTIONNAIRE_SECTION_TITLE_LABEL: 'Section title',
  MASONRY_QUESTIONNAIRE_SECTION_TITLE_HINT:
    'Optional. Short, label-style heading — e.g., "Health Basics", "Lifestyle". The title renders as a category pill at the top of each question in the section.',

  // Questions array
  MASONRY_QUESTIONNAIRE_QUESTIONS_LABEL: 'Questions',
  MASONRY_QUESTIONNAIRE_QUESTIONS_HINT:
    'Questions in this section, in display order.',
  MASONRY_QUESTIONNAIRE_QUESTION_ADD_LABEL: 'Add question',
  MASONRY_QUESTIONNAIRE_QUESTION_ITEM: 'Question',

  // Group labels (used as labels on the wrapping objects that group related fields)
  MASONRY_QUESTIONNAIRE_GROUP_QUESTION: 'Question',
  MASONRY_QUESTIONNAIRE_GROUP_CHOICE: 'Multiple choice options',
  MASONRY_QUESTIONNAIRE_GROUP_QUANTITY: 'Number input options',

  // Common per-question fields
  MASONRY_QUESTIONNAIRE_QUESTION_TEXT_LABEL: 'Question Label',

  MASONRY_QUESTIONNAIRE_ANSWER_TYPE_LABEL: 'Response Type',
  MASONRY_QUESTIONNAIRE_ANSWER_TYPE_HINT:
    'Determines what answer fields the question will collect.',
  MASONRY_QUESTIONNAIRE_ANSWER_TYPE_CHOICE: 'Multiple choice',
  MASONRY_QUESTIONNAIRE_ANSWER_TYPE_QUANTITY: 'Number with unit',
  MASONRY_QUESTIONNAIRE_ANSWER_TYPE_TEXT: 'Short text',
  MASONRY_QUESTIONNAIRE_ANSWER_TYPE_DATE: 'Date',
  MASONRY_QUESTIONNAIRE_ANSWER_TYPE_DATE_WITH_OPTION: "Date or 'time ago'",
  MASONRY_QUESTIONNAIRE_ANSWER_TYPE_TIME: 'Time of day',

  MASONRY_QUESTIONNAIRE_QUESTION_CODE_LABEL: 'Question clinical code',
  MASONRY_QUESTIONNAIRE_QUESTION_CODE_HINT:
    'Maps this question to a standard health data code (LOINC or League).',

  MASONRY_QUESTIONNAIRE_QUESTION_HINT_LABEL: 'Hint',
  MASONRY_QUESTIONNAIRE_QUESTION_HINT_HINT:
    'Short helper text shown directly below the question label. Use to clarify what kind of answer you expect or define an ambiguous term. Keep it brief — for longer explanations, use "Why we ask".',

  MASONRY_QUESTIONNAIRE_WHY_WE_ASK_LABEL: 'Why we ask',
  MASONRY_QUESTIONNAIRE_WHY_WE_ASK_HINT:
    'Shown as a subtle banner under the question. Use to normalize sensitive questions and explain how the answer informs care.',

  MASONRY_QUESTIONNAIRE_REQUIRED_LABEL: 'Required',
  MASONRY_QUESTIONNAIRE_REQUIRED_HINT:
    'Check this if the answer is mandatory. If true, the question must be presented to all members regardless of branching; a missing answer results in an incomplete response.',

  // Behavior group
  MASONRY_QUESTIONNAIRE_BEHAVIOR_LABEL: 'Behavior',
  MASONRY_QUESTIONNAIRE_BEHAVIOR_HINT:
    'How this question behaves — whether members must answer, whether existing data pre-fills, and whether they can edit later.',
  MASONRY_QUESTIONNAIRE_PREPOPULATE_LABEL: 'Prepopulate from member data',
  MASONRY_QUESTIONNAIRE_PREPOPULATE_HINT:
    "If on, the member's existing data (prior responses, customer APIs, wearables) pre-fills the answer when available. No effect if no data source is mapped.",
  MASONRY_QUESTIONNAIRE_EDITABLE_LABEL: 'Editable after submit',
  MASONRY_QUESTIONNAIRE_EDITABLE_HINT:
    "If on, members can edit their answer after submitting. Usually off for HRAs since they're a snapshot in time.",

  // Multiple choice
  MASONRY_QUESTIONNAIRE_ALLOW_MULTIPLE_LABEL: 'Allow multiple answers',
  MASONRY_QUESTIONNAIRE_ALLOW_MULTIPLE_HINT:
    'Lets the member select more than one option. When off, only one option can be picked.',
  MASONRY_QUESTIONNAIRE_DISPLAY_AS_DROPDOWN_LABEL: 'Display as dropdown',
  MASONRY_QUESTIONNAIRE_DISPLAY_AS_DROPDOWN_HINT:
    'If on, the options render as a dropdown rather than visible radio buttons or checkboxes. Useful for long lists.',
  MASONRY_QUESTIONNAIRE_MIN_SELECTION_LABEL: 'Minimum selections required',
  MASONRY_QUESTIONNAIRE_MIN_SELECTION_HINT:
    'Member must select at least this many options.',
  MASONRY_QUESTIONNAIRE_MAX_SELECTION_LABEL: 'Maximum selections allowed',
  MASONRY_QUESTIONNAIRE_MAX_SELECTION_HINT:
    "Member can't select more than this many options.",
  MASONRY_QUESTIONNAIRE_ANSWER_OPTIONS_LABEL: 'Answer options',
  MASONRY_QUESTIONNAIRE_ANSWER_OPTION_ADD_LABEL: 'Add option',
  MASONRY_QUESTIONNAIRE_OPTION_ITEM: 'Option',
  MASONRY_QUESTIONNAIRE_OPTION_CODE_LABEL: 'Answer code',
  MASONRY_QUESTIONNAIRE_OPTION_CODE_HINT: 'Pick the answer code.',
  MASONRY_QUESTIONNAIRE_OPTION_DISPLAY_LABEL: 'Answer Label',
  MASONRY_QUESTIONNAIRE_OPTION_VALUE_LABEL: 'Numeric value (for scoring)',
  MASONRY_QUESTIONNAIRE_OPTION_VALUE_HINT:
    "Used for ordinal/Likert scoring. Leave blank when scoring doesn't apply.",
  MASONRY_QUESTIONNAIRE_OPTION_EXCLUSIVE_LABEL:
    'Exclusive (clears other selections)',
  MASONRY_QUESTIONNAIRE_OPTION_EXCLUSIVE_HINT:
    "For 'None of the above', 'Don't know', or 'Prefer not to say' options.",

  // Number with unit
  MASONRY_QUESTIONNAIRE_UNIT_LABEL: 'Unit',
  MASONRY_QUESTIONNAIRE_UNIT_HINT:
    "Unit of measurement for the member's answer (e.g., cm, kg). Pre-fills from the question code's default.",
  MASONRY_QUESTIONNAIRE_UNIT_DISPLAY_LABEL: 'Unit label',
  MASONRY_QUESTIONNAIRE_UNIT_DISPLAY_HINT:
    'Member-facing label shown next to the input (e.g. "kg", "lb", "cm"). Translatable per locale. Distinct from Unit, which is the reference used for conversion and coding.',
  MASONRY_QUESTIONNAIRE_ALTERNATE_UNIT_LABEL: 'Alternate unit (optional)',
  MASONRY_QUESTIONNAIRE_ALTERNATE_UNIT_HINT:
    'Optional second unit shown alongside the primary (e.g. lbs alongside kg). The form converts between them.',
  MASONRY_QUESTIONNAIRE_ALLOW_DECIMAL_LABEL: 'Allow decimal places',
  MASONRY_QUESTIONNAIRE_ALLOW_DECIMAL_HINT:
    'Whether the member can enter decimal values (e.g., 5.5).',
  MASONRY_QUESTIONNAIRE_MIN_VALUE_LABEL: 'Minimum value',
  MASONRY_QUESTIONNAIRE_MIN_VALUE_HINT:
    'The lowest value the member can enter.',
  MASONRY_QUESTIONNAIRE_MAX_VALUE_LABEL: 'Maximum value',
  MASONRY_QUESTIONNAIRE_MAX_VALUE_HINT:
    'The highest value the member can enter.',

  // Short text — textOptions group
  MASONRY_QUESTIONNAIRE_TEXT_OPTIONS_LABEL: 'Text input options',
  MASONRY_QUESTIONNAIRE_TEXT_OPTIONS_HINT:
    'Layout and format for free-text answers.',
  MASONRY_QUESTIONNAIRE_TEXT_FORMAT_LABEL: 'Format',
  MASONRY_QUESTIONNAIRE_TEXT_FORMAT_HINT:
    'The format expected for the answer — plain text, email, or phone number.',
  MASONRY_QUESTIONNAIRE_TEXT_FORMAT_PLAIN: 'Plain text',
  MASONRY_QUESTIONNAIRE_TEXT_FORMAT_EMAIL: 'Email',
  MASONRY_QUESTIONNAIRE_TEXT_FORMAT_PHONE: 'Phone number',
  MASONRY_QUESTIONNAIRE_INPUT_METHOD_LABEL: 'Input style',
  MASONRY_QUESTIONNAIRE_INPUT_METHOD_HINT:
    'How the input is drawn. Line is one row tall — for short answers like a name. Box is multi-row — for longer prose.',
  MASONRY_QUESTIONNAIRE_INPUT_METHOD_LINE: 'Single line',
  MASONRY_QUESTIONNAIRE_INPUT_METHOD_BOX: 'Multi-line box',
  MASONRY_QUESTIONNAIRE_CHARACTER_LIMIT_LABEL: 'Character limit',
  MASONRY_QUESTIONNAIRE_CHARACTER_LIMIT_HINT:
    'Maximum number of characters the member can enter. Leave empty for no limit.',

  // Date / date with option — dateValidation group
  MASONRY_QUESTIONNAIRE_DATE_VALIDATION_LABEL: 'Date validation',
  MASONRY_QUESTIONNAIRE_DATE_VALIDATION_HINT:
    'Bounds and input style for the date picker.',
  MASONRY_QUESTIONNAIRE_DATE_INPUT_METHOD_LABEL: 'Date input style',
  MASONRY_QUESTIONNAIRE_DATE_INPUT_METHOD_HINT:
    "Use Date pick for full date entry; Month / year for approximate dates like 'when were you diagnosed'.",
  MASONRY_QUESTIONNAIRE_DATE_INPUT_METHOD_DATE_PICK: 'Date pick',
  MASONRY_QUESTIONNAIRE_DATE_INPUT_METHOD_MONTH_YEAR: 'Month / year',
  MASONRY_QUESTIONNAIRE_MAX_DATE_VALUE_LABEL: 'Maximum date',
  MASONRY_QUESTIONNAIRE_MAX_DATE_VALUE_HINT:
    'The latest date the member can enter.',
  MASONRY_QUESTIONNAIRE_MIN_DATE_VALUE_LABEL: 'Minimum date',
  MASONRY_QUESTIONNAIRE_MIN_DATE_VALUE_HINT:
    'The earliest date the member can enter.',
  MASONRY_QUESTIONNAIRE_USE_CURRENT_DATE_MAX_LABEL: 'Lock max to today',
  MASONRY_QUESTIONNAIRE_USE_CURRENT_DATE_MAX_HINT:
    "Lock the latest acceptable date to today — useful when the date can't be in the future (e.g., birth date).",
  MASONRY_QUESTIONNAIRE_USE_CURRENT_DATE_MIN_LABEL: 'Lock min to today',
  MASONRY_QUESTIONNAIRE_USE_CURRENT_DATE_MIN_HINT:
    "Lock the earliest acceptable date to today — useful when the date can't be in the past (e.g., follow-up appointment).",

  // Time — timeValidation group
  MASONRY_QUESTIONNAIRE_TIME_VALIDATION_LABEL: 'Time validation',
  MASONRY_QUESTIONNAIRE_TIME_VALIDATION_HINT: 'Bounds for the time picker.',
  MASONRY_QUESTIONNAIRE_MAX_TIME_LABEL: 'Maximum time',
  MASONRY_QUESTIONNAIRE_MAX_TIME_HINT:
    'Latest time of day the member can enter.',
  MASONRY_QUESTIONNAIRE_MIN_TIME_LABEL: 'Minimum time',
  MASONRY_QUESTIONNAIRE_MIN_TIME_HINT:
    'Earliest time of day the member can enter.',

  // Date with options
  MASONRY_QUESTIONNAIRE_DATE_OPTIONS_LABEL: 'Date options',
  MASONRY_QUESTIONNAIRE_DATE_OPTION_ADD_LABEL: 'Add date option',
  MASONRY_QUESTIONNAIRE_DATE_OPTION_ITEM: 'Date option',
  MASONRY_QUESTIONNAIRE_DATE_OPTION_CODE_LABEL: 'Code',
  MASONRY_QUESTIONNAIRE_DATE_OPTION_CODE_HINT: 'Pick the code.',
  MASONRY_QUESTIONNAIRE_DATE_OPTION_DISPLAY_LABEL: 'Answer Label',
  MASONRY_QUESTIONNAIRE_DATE_OPTION_VALUE_LABEL: 'Numeric offset',
  MASONRY_QUESTIONNAIRE_DATE_OPTION_VALUE_HINT:
    "Combined with unit. E.g. -3 with unit=month means '3 months ago'.",
  MASONRY_QUESTIONNAIRE_DATE_OPTION_UNIT_LABEL: 'Unit',
  MASONRY_QUESTIONNAIRE_DATE_OPTION_UNIT_HINT:
    'Optional unit reference for this date option.',

  // Branching field — questionnaire-specific labels the schema declares for
  // the generic conditionalAction control (`x-entity-label`/hint/action/source).
  // The control itself owns its chrome + generic fallbacks in
  // `conditional-action-strings.ts` (CONDITIONAL_ACTION_*); these are the
  // per-schema overrides that keep the field consistent with the rest of the
  // questionnaire's keys.
  MASONRY_QUESTIONNAIRE_BRANCHING_LABEL: 'Branching',
  MASONRY_QUESTIONNAIRE_BRANCHING_HINT:
    'Define how the flow continues after this question is answered. Rules are evaluated in order; the first match wins. Leave empty to continue to the next question in linear order.',
  MASONRY_QUESTIONNAIRE_BRANCHING_EMPTY_HINT:
    'Add a rule to send members to different questions based on how they answer',
  MASONRY_QUESTIONNAIRE_BRANCHING_GO_TO_LABEL: 'go to',
  MASONRY_QUESTIONNAIRE_BRANCHING_ANSWER_SUBJECT_LABEL: 'answer',
  MASONRY_QUESTIONNAIRE_QUESTION_SUBJECT_LABEL: 'Question',
  MASONRY_QUESTIONNAIRE_DATA_POINT_SUBJECT_LABEL: 'Data point',
  MASONRY_QUESTIONNAIRE_BRANCHING_RULES_LABEL: 'Rules',
  MASONRY_QUESTIONNAIRE_BRANCHING_ADD_RULE_LABEL: 'Add rule',
  MASONRY_QUESTIONNAIRE_BRANCHING_RULE_ITEM_LABEL: 'Rule',
  MASONRY_QUESTIONNAIRE_BRANCHING_DEFAULT_LABEL: 'All other cases go to',
  MASONRY_QUESTIONNAIRE_BRANCHING_DEFAULT_HINT:
    'Where the flow goes when no rule above matches. Leave empty to continue linearly.',
};
